import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService, UtilsService, AuthenticationService } from 'src/app/_services';
import { CuponView } from 'src/app/_models/coupons';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Observable, forkJoin, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { BasketService } from 'src/app/_services/basket.service';
import { User } from 'src/app/_models';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { environment } from 'src/environments/environment';


declare const $ : any;

@Component({
  selector: 'app-current-coupons',
  templateUrl: './current-coupons.component.html',
  styleUrls: ['./current-coupons.component.css']
})
export class CurrentCouponsComponent implements OnInit {
 
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();

  private goBack : boolean = false;

  constructor(    
    private users : UserService,
    public utils: UtilsService,
    public translate: TranslateService,
    private toastr: ToastrService,
    private auth: AuthenticationService,
    public dom  : DomSanitizer,
    public route : ActivatedRoute,
    public location : Location,
    private formBuilder : FormBuilder,
    private basket : BasketService,
    public router : Router
    ) {
    }

  Cupones : CuponView[] = [];
  HasCoupons: boolean  = false;
  HasCard: boolean = false;
  formCoupons : FormGroup;
  Showmsg: boolean  | null  = null
  loading : boolean = false;

  ngOnInit() {

    this.goBack =  this.route.snapshot.queryParams.b == "1";
    this.HasCoupons = false;
    this.HasCard = false;
    this.Cupones = new Array();

    this.formCoupons = this.formBuilder.group({
    });

  

    this.auth.currentUser.subscribe( user => {
      this.refresh(user);
    });
    
  }

  refresh(user? : User){
    if (! user){
      user = this.auth.currentUserValue;
    }

    if (user && user.id_plusi_card.trim() != '' ) {
      this.HasCard = true;
      this.users.getCupones(user.id_plusi_card, this.translate.currentLang).subscribe( cupon => {
        
        this.Cupones.forEach( coupon =>{
            this.formCoupons.removeControl(coupon.vou_id);
        });
        this.Cupones = new Array();
        cupon.forEach(c => {
          let cp : CuponView;
          cp = new CuponView();
          cp.vou_id = c.vou_id;
          cp.vou_type = c.vou_type;
          cp.valid_until = c.valid_until;
          cp.exclusive = c.exclusive;
          cp.selected = c.selected;
  
          c.texts.forEach(t=>{
  
            switch (t.text_type) {
              case 1: {
                cp.Titulo = t.text;
                break;
              }
              case 2: {
                cp.Descripcion += ' ' + t.text;
                break;
              }
              case 3: {
                cp.ImporteAbsoluto = t.text;
                break;
              }
              case 4: {
                cp.PorcentajeRelativo = t.text;
                break;
              }
              case 5: {
                cp.Articulos = t.text;
                break;
              }
              case 6: {
                //cp.SeccionArticulos = t.text;
                cp.Articulos = t.text;
                break;
              }
              case 7: {
                cp.ValidezOtros = t.text;
                break;
              }
              case 8: {
                cp.URLImg = t.text;
                break;
              }
              case 9: {
                cp.EAN = t.text;
                break;
              }
              case 10: {
                cp.RGB = t.text  ?  t.text.replace( /;/g , ',' ) : '' ;
                break;
              }
            }
          });
          this.formCoupons.addControl(cp.vou_id.toString(), new FormControl(cp.selected));
          this.Cupones.push(cp);
        });
        this.HasCoupons = true;
      }); 
    }    
  }

  onValidate(codecupondiscount:string)
  {
    this.Showmsg = null;
    this.loading = true;
    this.users.validCupon(codecupondiscount).subscribe({
      next: (res: any) => {
        //this.toastr.success(this.translate.instant('USERCOUPONS.OK_VALID_CODE'));
        this.Showmsg = true;
        this.loading = false;
        this.refresh();
      },
      error: () =>{
        //this.toastr.error(this.translate.instant('USERCOUPONS.ERR_VALID_CODE'));
        this.Showmsg = false;
        this.loading = false;
      }
    });
  }

  onApply(){

    let actives : Observable<any>[] = [];

    this.Cupones.forEach( coupon => {
      if (this.formCoupons.controls[coupon.vou_id].value){
        actives.push(this.users.requestSetCuponActivo(this.auth.currentUserValue.id_plusi_card, coupon));
      } else {
        actives.push(this.users.requestSetCuponInactivo(this.auth.currentUserValue.id_plusi_card, coupon));       
      }
    });

    forkJoin(actives).pipe(
      tap( result => {
        this.toastr.success(this.translate.instant('USERCOUPONS.APPLIED'));
        this.basket.get().subscribe();
      }),
      catchError( error => {
          this.toastr.error(this.translate.instant('USERCOUPONS.ERROR_ACTIVATING'));
          this.basket.get().subscribe();
          return throwError (error);
      })
    ).subscribe();
    
    if (this.goBack){
      this.location.back(); 
    }
    this.notifyParent.emit();

  }
 
  
  goToCard(){

    $('#app-user-coupons-modal').modal('hide');
    this.router.navigate(['/user/card']);

  }

}
